import * as React from 'react';

import { DescriptionPage_CourseType as CourseType } from '__generated__/graphql-types';

import Notification from 'bundles/course-cards/components/common/Notification';
import { useCourseCards } from 'bundles/page-config-common/contexts/consumer/ConsumerCourseCardsContext';
import { useModalManager } from 'bundles/page-config-common/contexts/consumer/ModalManagerContext';

const ConsumerNotificationsNotConfigurable = () => {
  const { currentActionNotificationTypeName, isNotificationVisible, modifiedProductModalData } = useModalManager();
  const { courseCards } = useCourseCards();

  if (!modifiedProductModalData || !courseCards) {
    return null;
  }

  const modifiedCourseId = modifiedProductModalData.courseId;
  const courseDataFromModifiedId = courseCards.find((course) => course.courseId === modifiedCourseId);

  if (!courseDataFromModifiedId) {
    return null;
  }

  const { courseSlug, courseName, courseMetadata, courseId } = courseDataFromModifiedId;

  return (
    <div>
      <Notification
        messageTypeName={currentActionNotificationTypeName}
        isNotificationVisible={isNotificationVisible}
        courseName={courseName}
        courseSlug={courseSlug}
        courseId={courseId}
        isRhymeProject={courseMetadata?.courseType === CourseType.RhymeProject}
      />
    </div>
  );
};

export default ConsumerNotificationsNotConfigurable;
